import { Box, Container, Grid, Modal } from "@mui/material";
import { useEffect, useState } from "react";
import React from "react";
import { session } from "../../data/session";
import { useGlobal } from "../../utils/GlobalContext";
import { UserProfile } from "../../data/userProfile";
import HTMLReactParser from "html-react-parser";

export default function SessionInfoModal(props: {show: any, onClose: ()=> void, sessionModel:session}){
    const { state } = useGlobal();
    const [open, setOpen] = React.useState(false);
    const [speakers, setSpeakers] = useState<UserProfile[]>([]);
    const handleClose = () => {
        setOpen(false);
        setSpeakers([]);
        props.onClose();
    };
    useEffect(() => {
        setOpen(props.show);
        let tempSpeakers:UserProfile[]=[];
        props.sessionModel.SessionSpeakers.forEach(speaker=>{
            const tempSelectedSpeaker: UserProfile[] = state.Profiles.filter(function (el){
                return el.Id=== speaker.UserId;
            });
            tempSpeakers.push(tempSelectedSpeaker[0]);
        });
        setSpeakers(tempSpeakers);
    }, [props.show]);

    if (!open) return null;
    return (
        <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="sessionInfoModal">
                <div className='sessionInfoForm'>
                    <img className="closeModal" src="https://cdn-icons-png.flaticon.com/128/399/399274.png" onClick={handleClose} alt=""/>
                    <Container>
                        <Box sx={{ flexGrow: 1 }}>
                            <Grid container spacing={2}>
                                {speakers.map((speaker)=>(
                                        <Grid item xs={12} md={3}>
                                            <center>
                                                <img className='KeynoteSpeakerImage' src={speaker.PictureLink} alt='KeyNoteSpeaker' title={speaker.FirstName + " " + speaker.LastName}/>
                                            </center>
                                        </Grid>
                                    )
                                )}
                                <Grid item xs={12} md={9} container justifyContent='flex-end' >
                                    <div className="SpeakerName"><h1 className='uppercase'>{props.sessionModel.Title}</h1></div> 
                                    <br/>
                                    <div className="textAccentColor4">
                                    {HTMLReactParser(props.sessionModel.Description)}
                                    </div>
                                </Grid>
                            </Grid>
                        </Box>
                    </Container>
                </div>
        </Modal>
    );
}
